<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">ระบบจองคิวแรงานต่างด้าว</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title title-tag="h2" class="font-weight-bold mb-1">
            ระบบจองคิวแรงานต่างด้าว
          </b-card-title>
          <!-- <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text> -->

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form class="auth-login-form mt-2" @submit.prevent>
              <!-- email -->
              <b-form-group label="ชื่อผู้ใช้งาน" label-for="login-username">
                <validation-provider #default="{ errors }" name="user" rules="required">
                  <b-form-input id="login-user" v-model="username" :state="errors.length > 0 ? false : null"
                    name="login-user" placeholder="Username" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">รหัสผ่าน</label>
                  <!-- <b-link :to="{ name: 'auth-forgot-password-v2' }">
                    <small>Forgot Password?</small>
                  </b-link> -->
                </div>
                <validation-provider #default="{ errors }" name="Password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="login-password" v-model="password" :state="errors.length > 0 ? false : null"
                      class="form-control-merge" :type="passwordFieldType" name="login-password"
                      placeholder="············" />
                    <b-input-group-append is-text>
                      <feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block @click="validationForm">
                เข้าสู่ระบบ
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";

import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store/index";

import axios from "axios";
import API from "@/connect/config";
export default {
  components: {

    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      username: "admin",
      password: "Password@1",
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      form: {
        username: '',
        password: ''
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    console.log("ID from URL:", id);
    if (id) {
      this.form.username = id;
      this.$router.push({ name: "view" });
      this.handleLogin();
    }
  },
  created() {
    // console.log("NODE_ENV:", process.env.NODE_ENV); // development, production, etc.
    //console.log("API:", API); // ควรได้ URL จาก .env
    // this.Login(); // ฟังก์ชันของคุณ
  },
  methods: {
    async Login() {
      //  console.log(API);
      //   console.log(this.username, this.password);

      // const _jwt = {
      //   companyId: '688c326434f99f8c75ea3418',
      //   userId: '688c326434f99f8c75ea3419',
      // }
      // localStorage.setItem("company_jwt", JSON.stringify(_jwt));
    
      // localStorage.setItem("refresh_token", 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55SWQiOiI2NmVkMjk0ZjYwY2M5N2M2OTYwNGQxNTIiLCJ1c2VySWQiOiI2NmVkMjk0ZjYwY2M5N2M2OTYwNGQxNTMiLCJyb2xlIjoiYWRtaW4iLCJmaXJzdG5hbWUiOiIiLCJsYXN0bmFtZSI6IiIsImNvbXBhbnlOYW1lIjoiY29tZGV2MSIsInVzZXJMaW1pdCI6MCwicm91dGVMaW1pdCI6MCwic3RhdHVzIjoiIiwicmVnaXN0cmF0aW9uU3RhcnQiOiIyMDI0LTA5LTIwIDAwOjAwOjAwIiwicmVnaXN0cmF0aW9uRW5kIjoiMjAyNi0xMi0zMSAyMzo1OTowMCIsImlhdCI6MTc1Mzk1Mzk3MiwiZXhwIjoxNzg1NTExNTcyfQ.mfO3oMvGJlBdwp3-7djJbRxqm2VEpRJO2zvnylA-CF_JVzemfjbU33VQX1FZH0cBFPwhxFqH6vcNg4WEnWwSSA');

     
      //   this.$router.push({ name: "home" });

      // return;

      await axios
        .post(`${API}login`, {
          username: this.username,
          password: this.password,
        })
        .then(async (res) => {
       //   console.log(res.data.message.refresh_token);

          localStorage.setItem("refresh_token", res.data.message.refresh_token);

          let jwt = await this.$store.dispatch(
            "getJwtDecode",
            res.data.message.refresh_token
          );



          // console.log("fgfgfgfgfg");
          // const urlpermit = `${API}permit`;
          // const refreshToken = res.data.message.refresh_token;
          // try {
          //   const restoken = await axios.post(
          //     urlpermit,
          //     {}, // ส่ง empty body
          //     {
          //       headers: {
          //         Authorization: refreshToken,
          //       },
          //     }
          //   );
          //   const _acc = restoken.data.message.access_token;
          //   console.log(_acc);
          //   console.log("sssss");
          // } catch (error) {
          //   console.error(
          //     "❌ Error while getting token:",
          //     error.response?.data || error.message
          //   );
          // }

          //   localStorage.setItem("company_jwt", JSON.stringify(jwt));

          // const jwt = await this.$store.dispatch(
          //   "getJwtDecode",
          //   res.data.message.refresh_token
          // );
          localStorage.setItem("company_jwt", JSON.stringify(jwt));

        //  console.log(jwt);
          if (res.data.status == 200) {
            this.$router.push({ name: "home" });
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "เข้าสู่ระบบสำเร็จ",
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${res.data.message}`,
                icon: "EditIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `${error.response.data.message}`,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });

      return;
      //   res_user.data.message.data.map((el) => {
      //     if (el.rule == "member" && el.lineId == line_userId) {
      //       localStorage.setItem("profile_visitor", JSON.stringify(el));
      //       if (this.page == 1) {
      //         this.$router.push({ name: "home" });
      //       } else if (this.page == 2) {
      //         this.$router.push({ name: "addMeet" });
      //       } else if (this.page == 3) {
      //         this.$router.push({ name: "qrcode" });

      //         // this.$router.push({ name: 'addMeet' });
      //       }

      // });
    },
    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.Login(this.username, this.password);
          // this.$toast({
          //   component: ToastificationContent,
          //   props: {
          //     title: "Form Submitted",
          //     icon: "EditIcon",
          //     variant: "success",
          //   },
          // });
        }
      });
    },
    handleLogin() {
      this.passwordInvalid = this.form.password.trim() === '';

      const user = this.users.find(u => u.id === this.form.username);
      this.idInvalid = !user;

      if (!this.passwordInvalid && user) {
        this.currentUser = user;
        this.showInfo = true;
      }
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
